var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sarala-table',{attrs:{"model":_vm.model,"query":_vm.query},scopedSlots:_vm._u([{key:"actionHandler",fn:function(){return [_c('ResellerUserActions',{ref:"actionHandler"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }